/* global axios */
// NOTICE: KAPTION-INTEGRATION
// ai-takeover.TAKEOVER.1 — a person takes the conversation from the Kaption assistant.
import ApiClient from './ApiClient';

class KaptionAiTakeover extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  // 200 { id, status, assignee }; 409 { error: 'not_assistant_owned', owner } when someone
  // else got there first (ai-takeover.TAKEOVER.2).
  take(conversationId) {
    return axios.post(`${this.url}/${conversationId}/kaption_takeover`);
  }
}

export default new KaptionAiTakeover();
